import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    title: 'Expozoare',
    titleEn: 'Pallet displays',
    titleBg: 'палетен дисплей',
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/ex.png',
    imagewidth:300,
    imageheight:260,
    cod:'ex',
    subTip:"",
    meniu:true,
    comandaExpozorUrl:'/orders',
    instructiuniUrl:'',
    instructiuniUrlEn: '',
    instructiuniUrlBg: '',
    prezentareUrl:'',
    prezentareUrlEn: '',
    prezentareUrlBg: '',
    preturiUrl:'',
    preturiUrlEn: '',
    preturiUrlBg: '',
    videoUrl:'/video',
    codVideo:'exp',
  },
  
  {
    id: uuid(),
    title: 'Jaluzele verticale',
    titleEn: 'Vertical blinds',
    titleBg: 'Вертикални затени',
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/jv.jpg',
    cod:'jv',
    subTip:"JVV",
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_jvv.pdf',
    instructiuniUrlEn: '/pdf/masuratori_jvv_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_jvv_bg.pdf',
    prezentareUrl:'/pdf/prezentare_jvv.pdf',
    prezentareUrlEn: '/pdf/prezentare_jvv_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_jvv_bg.pdf',
    preturiUrl:'/pdf/preturi_jvv.pdf',
    preturiUrlEn: '/pdf/preturi_jvv_en.pdf',
    preturiUrlBg: '/pdf/preturi_jvv_bg.pdf',
    videoUrl:'/video',
    codVideo:'jvv',
  },
  {
    id: uuid(),
    title: 'Jaluzele tip perdea',
    titleEn: 'Curtain-style blinds',
    titleBg: 'Щори тип завеса',
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/jvp.jpg',
    cod:'jv',
    subTip:"JVP",
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_jvp.pdf',
    instructiuniUrlEn: '/pdf/masuratori_jvp_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_jvp_bg.pdf',
    prezentareUrl:'/pdf/prezentare_jvp.pdf',
    prezentareUrlEn: '/pdf/prezentare_jvp_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_jvp_bg.pdf',
    preturiUrl:'/pdf/preturi_jvp.pdf',
    preturiUrlEn: '/pdf/preturi_jvp_en.pdf',
    preturiUrlBg: '/pdf/preturi_jvp_bg.pdf',
    videoUrl:'/video',
    codVideo:'jvp',
  },
  {
    id: uuid(),
    title: 'Jaluzele tip Idilia',
    titleEn: 'Idilia blinds',
    titleBg: 'Затени тип Идилія',
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/jvi.jpg',
    cod:'jv',
    subTip:"JVI",
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_jvi.pdf',
    instructiuniUrlEn: '/pdf/masuratori_jvi_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_jvi_bg.pdf',
    prezentareUrl:'/pdf/prezentare_jvi.pdf',
    prezentareUrlEn: '/pdf/prezentare_jvi_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_jvi_bg.pdf',
    preturiUrl:'/pdf/preturi_jvi.pdf',
    preturiUrlEn: '/pdf/preturi_jvi_en.pdf',
    preturiUrlBg: '/pdf/preturi_jvi_bg.pdf',
    videoUrl:'/video',
    codVideo:'jvi',
  },
  {
    id: uuid(),
    title: 'Jaluzele Plisate',
    titleEn: 'Pleated blinds',
    titleBg: 'плисирани щори',
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/roj.jpg',
    cod: 'ro',
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_roj.pdf',
    instructiuniUrlEn: '/pdf/masuratori_roj_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_roj_bg.pdf',
    subTip:"ROJ",
    prezentareUrl:'/pdf/prezentare_roj.pdf',
    prezentareUrlEn: '/pdf/prezentare_roj_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_roj_bg.pdf',
    preturiUrl:'/pdf/preturi_roj.pdf',
    preturiUrlEn: '/pdf/preturi_roj_en.pdf',
    preturiUrlBg: '/pdf/preturi_roj_bg.pdf',
    videoUrl:'/video',
    codVideo:'roj',
  },
  {
    id: uuid(),
    title: 'Rolete textile',
    titleEn: 'Textile blinds',
    titleBg: 'Затени тип Текстил',
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/ro.jpg',
    cod: 'ro',
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_ro.pdf',
    instructiuniUrlEn: '/pdf/masuratori_ro_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_ro_bg.pdf',
    subTip:"ROR",
    prezentareUrl:'/pdf/prezentare_ro.pdf',
    prezentareUrlEn: '/pdf/prezentare_ro_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_ro_bg.pdf',
    preturiUrl:'/pdf/preturi_ro.pdf',
    preturiUrlEn: '/pdf/preturi_ro_en.pdf',
    preturiUrlBg: '/pdf/preturi_ro_bg.pdf',
    videoUrl:'/video',
    codVideo:'ro',
  },
  // {
  //   id: uuid(),
  //   title: 'Rolete textile(vechi)',
  //   description:
  //     '',
  //   imageUrl: '/images/products/ro.jpg',
  //   cod: 'ro',
  //   meniu:true,
  //   instructiuniUrl:'/pdf/masuratori_ro.pdf',
  //   subTip:"",
  //   prezentareUrl:'/pdf/prezentare_ro.pdf',
  //   preturiUrl:'/pdf/preturi_ro.pdf',
  //   videoUrl:'/video',
  //   codVideo:'ro',
  // },
  {
    id: uuid(),
    title: 'Rulouri exterioare aplicate',
    titleEn: 'Surface-mounted external roller shutters', 
    titleBg: 'Външни ролетни щори за външен монтаж',   
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/aplicate.jpg',
    cod:'re',
    instructiuniUrl:'/pdf/masuratori_rea.pdf',
    instructiuniUrlEn: '/pdf/masuratori_rea_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_rea_bg.pdf',
    subTip:"REA",
    meniu:true,
    prezentareUrl:'/pdf/prezentare_rea.pdf',
    prezentareUrlEn: '/pdf/prezentare_rea_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_rea_bg.pdf',
    preturiUrl:'/pdf/preturi_rea.pdf',
    preturiUrlEn: '/pdf/preturi_rea_en.pdf',
    preturiUrlBg: '/pdf/preturi_rea_bg.pdf',
    videoUrl:'/video',
    codVideo:'rea',
  },
  {
    id: uuid(),
    title: 'Rulouri exterioare suprapuse',
    titleEn: 'Top-mounted exterior roller shutters', 
    titleBg: 'Външни ролетни щори за монтаж върху дограмата',   
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/suprapuse.jpg',
    cod:'re',
    instructiuniUrl:'/pdf/masuratori_res.pdf',
    instructiuniUrlEn: '/pdf/masuratori_res_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_res_bg.pdf',
    subTip:"RES",
    meniu:true,
    prezentareUrl:'/pdf/prezentare_res.pdf',
    prezentareUrlEn: '/pdf/prezentare_res_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_res_bg.pdf',
    preturiUrl:'/pdf/preturi_res.pdf',
    preturiUrlEn: '/pdf/preturi_res_en.pdf',
    preturiUrlBg: '/pdf/preturi_res_bg.pdf',
    videoUrl:'/video',
    codVideo:'res',
  },
  {
    id: uuid(),
    title: 'Rulouri exterioare transparente',
    titleEn: 'Transparent exterior roller blinds', 
    titleBg: 'Прозрачни външни ролетни щори',   
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/transparente.jpg',
    cod:'re',
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_ret.pdf',
    instructiuniUrlEn: '/pdf/masuratori_ret_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_ret_bg.pdf',
    subTip:"RET",
    prezentareUrl:'/pdf/prezentare_ret.pdf',
    prezentareUrlEn: '/pdf/prezentare_ret_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_ret_bg.pdf',
    preturiUrl:'/pdf/preturi_ret.pdf',
    preturiUrlEn: '/pdf/preturi_ret_en.pdf',
    preturiUrlBg: '/pdf/preturi_ret_bg.pdf',
    videoUrl:'/video',
    codVideo:'ret',
  },
  {
    id: uuid(),
    title: 'Usi garaj',
    titleEn: 'Garage doors', 
    titleBg: 'Врати на гараж',   
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/ug.jpg',
    cod:'ug',
    subTip:"",
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_ug.pdf',
    instructiuniUrlEn: '/pdf/masuratori_ug_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_ug_bg.pdf',
    prezentareUrl:'/pdf/prezentare_ug.pdf',
    prezentareUrlEn: '/pdf/prezentare_ug_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_ug_bg.pdf',
    preturiUrl:'/pdf/preturi_ug.pdf',
    preturiUrlEn: '/pdf/preturi_ug_en.pdf',
    preturiUrlBg: '/pdf/preturi_ug_bg.pdf',
    videoUrl:'/video',
    codVideo:'ug',
  },
  {
    id: uuid(),
    title: 'Plase anti-insecte',
    titleEn: 'Insect screens', 
    titleBg: 'Екран за мухи',   
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/pi.jpg',
    cod:'pi',
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_pi.pdf',
    instructiuniUrlEn: '/pdf/masuratori_pi_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_pi_bg.pdf',
    subTip:"",
    prezentareUrl:'/pdf/prezentare_pi.pdf',
    prezentareUrlEn: '/pdf/prezentare_pi_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_pi_bg.pdf',
    preturiUrl:'/pdf/preturi_pi.pdf',
    preturiUrlEn: '/pdf/preturi_pi_en.pdf',
    preturiUrlBg: '/pdf/preturi_pi_bg.pdf',
    videoUrl:'/video',
    codVideo:'pi',
  },
  {
    id: uuid(),
    title: 'Jaluzele orizontale',
    titleEn: 'Horizontal blinds', 
    titleBg: 'Ленти затени',   
    description:'',
    descriptionEn: '',
    descriptionBg: '',
    imageUrl: '/images/products/jo.jpg',
    cod:'jo',
    meniu:true,
    instructiuniUrl:'/pdf/masuratori_jo.pdf',
    instructiuniUrlEn: '/pdf/masuratori_jo_en.pdf',
    instructiuniUrlBg: '/pdf/masuratori_jo_bg.pdf',
    subTip:"",
    prezentareUrl:'/pdf/prezentare_jo.pdf',
    prezentareUrlEn: '/pdf/prezentare_jo_en.pdf',
    prezentareUrlBg: '/pdf/prezentare_jo_bg.pdf',
    preturiUrl:'/pdf/preturi_jo.pdf',
    preturiUrlEn: '/pdf/preturi_jo_en.pdf',
    preturiUrlBg: '/pdf/preturi_jo_bg.pdf',
    videoUrl:'/video',
  },
  {
    id: uuid(),
    title: 'Masuratori/Servicii',
    titleEn: 'Measurements/Services', 
    titleBg: 'Мерки/Услуги',   
    descriptionEn: '',
    descriptionBg: '',
    description:'',
    imageUrl: '/images/products/masuratori.png',
    cod:'sv',
    instructiuniUrl:'',
    instructiuniUrlEn: '',
    instructiuniUrlBg: '',
    subTip:""
  },
  // {
  //   id: uuid(),
  //   title: 'Jaluzele verticale ( modul vechi)',
  //   description:'INACTIV - pentru comenzi noi folositi noile module',
  //   imageUrl: '/images/products/jvvechi.jpg',
  //   cod:'jv',
  //   subTip:"",
  //   meniu:false,
  //   instructiuniUrl:'/pdf/masuratori_jv.pdf',
  //   prezentareUrl:'/pdf/prezentare_jv.pdf',
  //   preturiUrl:'/pdf/preturi_jv.pdf',
  //   videoUrl:'/video',
  //   codVideo:'jv',
  // },
  // {
  //   id: uuid(),
  //   title: 'Rulouri exterioare',
  //   description:'Modul vechi: se va folosi doar pentru comenzile vechi de rulouri exterioare netransmise inca.',
  //   imageUrl: '/images/products/dezactivat.png',
  //   cod:'re',
  //   instructiuniUrl:'http://larexir.ro/product/rulouri-aplicate-montaj/',
  //   subTip:""
  // }
];
